$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('common.ui', ['common.backend']).directive('interactionSwitch', function($q, $stateParams, $state, AudioManager, Analytics, Backend, resolveChannel, ClassroomSettings) {
    return {
      templateUrl: 'components/interaction-switch.html',
      link: function($scope, elem, attr) {
        $scope.classroom = [];
        if (!ClassroomSettings.get().code) {
          ClassroomSettings.set({
            interactive: false,
            code: 0
          });
        }
        $scope.slidetype = attr.type;
        $scope.showSetupPanel = false;
        $scope.classroom.code = ClassroomSettings.get().code;
        $scope.classroom.interactive = ClassroomSettings.get().interactive;
        $scope.togglePanel = (function() {
          $scope.showSetupPanel = ($scope.showSetupPanel ? false : true);
        });
        $scope.toggle = (function() {
          if (ClassroomSettings.get().interactive === true) {
            ClassroomSettings.set({
              interactive: false,
              code: 0
            });
            $scope.classroom.code = ClassroomSettings.get().code;
            $scope.classroom.interactive = ClassroomSettings.get().interactive;
            $scope.showSetupPanel = false;
          } else {
            Backend.create().then((function(code) {
              ClassroomSettings.set({
                interactive: true,
                code: code
              });
              $scope.classroom.code = ClassroomSettings.get().code;
              $scope.classroom.interactive = ClassroomSettings.get().interactive;
              $scope.showSetupPanel = true;
              resolveChannel('organizer', code);
              return code;
            }));
          }
        });
      }
    };
  }).directive('jwplayer', function($rootScope) {
    return {
      templateUrl: 'components/jwplayer.html',
      scope: {
        video: '=',
        image: '=',
        repeat: '=',
        mute: '=',
        autostart: '='
      },
      link: (function($scope, elem, attr, $window) {
        var isFirefox = navigator.userAgent.indexOf("Firefox") != -1 ? true : false;
        var options = {
          file: $scope.video,
          image: $scope.image,
          autostart: (isFirefox ? 'false' : 'viewable'),
          width: '100%',
          height: '100%',
          volume: 25,
          title: false,
          stretching: 'fill',
          preload: 'auto',
          controls: false,
          repeat: ($scope.repeat == true ? true : false),
          mute: ($scope.mute == true ? true : false)
        };
        var player = jwplayer('video-player').setup(options);
        $scope.formatTime = (function(t) {
          var s = (t % 60) + '';
          var m = (t / 60 << 0) + '';
          return m + ':' + (s.length == 1 ? '0' : '') + s;
        });
        player.on('ready', function() {
          player.setControls(false);
        });
        player.on('bufferChange', function(e) {
          $scope.$apply(function() {
            $scope.duration = $scope.formatTime(Math.round(e.duration));
            $scope.position = $scope.formatTime(Math.round(e.position));
          });
        });
        player.on('time', function(e) {
          $scope.$apply(function() {
            $scope.position = $scope.formatTime(Math.round(e.position));
            $scope.showDetails = true;
          });
        });
        player.on('displayClick', function(e) {
          $scope.$apply(function() {
            $scope.toggleVideo();
          });
        });
        player.on('firstFrame', function() {
          $scope.$apply(function() {
            $scope.isPlaying = true;
            $scope.isLoading = false;
          });
        });
        player.on('complete', function() {
          if ($scope.$parent.slide.redirect) {
            window.location.href = $scope.$parent.slide.redirect;
          } else {
            $scope.$apply(function() {
              $scope.$parent.next();
            });
          }
        });
        $scope.toggleVideo = (function() {
          if (player.getState() === 'playing') {
            $scope.stopVideo();
          } else {
            $scope.playVideo();
          }
        });
        $scope.stopVideo = (function() {
          player.setMute(true);
          player.pause(true);
          $scope.isPlaying = false;
          $('.jw__controls').fadeIn();
        });
        $scope.playVideo = (function() {
          player.setMute(false);
          player.pause(false);
          $scope.isPlaying = true;
        });
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
          $scope.stopVideo();
        });
        var timedelay = 1;
        var _delay;
        function delayCheck() {
          if (timedelay == 3 && $scope.isPlaying) {
            $('.jw__controls').fadeOut();
            timedelay = 1;
          }
          timedelay = timedelay + 1;
        }
        $(document).mousemove(function() {
          $('.jw__controls').fadeIn();
          timedelay = 1;
          clearInterval(_delay);
          _delay = setInterval(delayCheck, 1000);
        });
        _delay = setInterval(delayCheck, 1000);
      })
    };
  }).directive('fancybox', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        if (attrs.fancybox === 'false') {
          return true;
        }
        $(element).fancybox({
          scrolling: 'no',
          maxWidth: 1280,
          maxHeight: 600,
          fitToView: true,
          width: '90%',
          height: '90%',
          autoSize: true,
          closeClick: true,
          openEffect: 'none',
          closeEffect: 'none',
          padding: 0,
          buttons: ['slideShow', 'thumbs', 'close']
        });
      }
    };
  });
  return {};
});

